/* maaho-sample.js - the free fabric sample button, on category tiles and on the
   product page. It adds the sample paired to the fabric being shown straight to
   the cart, so the customer never leaves the page.

   A button carries:
     data-sample-variant   the Shopify variant to add
     data-sample-colour    the fabric's name, sent as a line-item property so the
                           order and the production system say which sample it is

   Which sample a fabric is paired to is read from custom.fabric_samples, written
   by load-fabric-samples.py from PrestaShop's own pairing table. It is never
   matched by fabric name: 636 of 1.830 pairings point at a differently named
   fabric, so a name lookup would send the wrong sample.

   Bound by delegation on the document, because assets/maaho-collection-tiles.js
   redraws the grid on every filter, sort and page change and those buttons have
   to work without being bound again.

   Styles: .btn-sample in assets/maaho-product.css,
           .product-card-button-sample in assets/maaho-collection.css. */

(function () {
  'use strict';

  /* Danish in every language - it is the stable key the order is read by, not a
     label. The visible text is translated; this is not. */
  var COLOUR_PROPERTY = 'Farve';

  function addSample(button) {
    var variantId = button.getAttribute('data-sample-variant');
    if (!variantId) return;

    var item = { id: Number(variantId), quantity: 1 };
    var colour = button.getAttribute('data-sample-colour');
    if (colour) {
      item.properties = {};
      item.properties[COLOUR_PROPERTY] = colour;
    }

    button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        /* Shopify answers a rejected line - sold out, no such variant - with 422
           and a JSON body. Announcing a success there would open a cart drawer
           that does not hold the sample. */
        if (!response.ok) throw new Error('sample rejected');
        /* assets/maaho-header.js listens for this and reopens the cart drawer,
           which is the customer's confirmation that the sample went in. */
        document.dispatchEvent(new CustomEvent('maaho:cartadd'));
      })
      .catch(function () {})
      .then(function () { button.disabled = false; });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-sample');
    if (!button) return;
    event.preventDefault();
    addSample(button);
  });
})();
